// extracted by mini-css-extract-plugin
export default {"content__about":"AboutSection_content__about__0P20V","text-content__about":"AboutSection_text-content__about__XLbDx","img__about":"AboutSection_img__about__fYRbM"};